import { mappingEnum } from "@/Core/Helpers/Helpers";
import { IPermissionsList } from "@/Core/Interfaces/IPermissions";

export default class PermissionsLists {
    public static User = {
        List: "Users List",
        Create: "Users Create",
        Edit: "Users Edit",
        Delete: "Users Delete",
        AssignRole: "Users Assign_Role",
        ResetPassword: "Users Reset_Password",
        SetManager: "Users Set_Manager",
        SetAssistant: "Users Set_Assistant",
        Profile: "Users Profile",
    };

    public AssistanceManager = "Assistant Manager";

    // Role
    public static Role = {
        List: "Role List",
        Create: "Role Create",
        Edit: "Role Edit",
        Delete: "Role Delete",
        Assign: "Role Assign_Permissions",
        revoke: "Role Revoke_Permissions",
    };

    // Country
    public static Country = {
        List: "Country List",
        Create: "Country Create",
        Edit: "Country Edit",
        Delete: "Country Delete",
        Trash: "Country Trash",
        RestoreDelete: "Country Restore_Delete",
        ForceDelete: "Country Force_Delete",
    };

    // City
    public static City = {
        List: "City List",
        Create: "City Create",
        Edit: "City Edit",
        Delete: "City Delete",
    };

    // Company
    public static Category = {
        List: "Category List",
        Create: "Category Create",
        Edit: "Category Edit",
        Delete: "Category Delete",
    };

    // Department
    public static Department = {
        List: "Department List",
        Create: "Department Create",
        Edit: "Department Edit",
        Delete: "Department Delete",
        SetManager: "Department Set_Manager",
    };

    public static Hotels = {
        List: "Hotels List",
        Create: "Hotels Create",
        Edit: "Hotels Edit",
        Delete: "Hotels Delete",
        Rooms: "Room Management",
        SetManager: "Hotels Set_Manager",
    };

    public static Venues = {
        List: "Venue List",
        Create: "Venue Create",
        Edit: "Venue Edit",
        Delete: "Venue Delete",
        Events: "Event Management",
        Payments: "Payments",
    };

    public static GuestHouses = {
        List: "Guest House List",
        Create: "Guest House Create",
        Edit: "Guest House Edit",
        Delete: "Guest House Delete",
        SetManager: "Guest House Set_Manager",
    };

    // Position
    public static Position = {
        List: "Position List",
        Create: "Position Create",
        Edit: "Position Edit",
        Delete: "Position Delete",
    };

    // Leave
    public static Leave = {
        List: "Leave List",
        direct: "Leave Direct_Create",
        Edit: "Leave Edit",
        // Delete: "Leave Delete",
        Force: "Leave Force",
        ManagerApprove: "Leave Manager_Approve",
        AssistantManagerApprove: "Leave Assistant_Manager_Approve",
        HRApprove: "Leave Human_Resource_Approve",
        AssistantHRApprove: "Leave Assistant_Human_Resource_Approve",
    };

    // DocumentTypes
    public static DocumentTypes = {
        List: "Document_Types List",
        Create: "Document_Types Create",
        Edit: "Document_Types Edit",
        Delete: "Document_Types Delete",
    };

    // Document
    public static Document = {
        List: "Document List",
        Create: "Document Create",
        Edit: "Document Edit",
        Delete: "Document Delete",
    };

    // Config
    public static Config = {
        All: "Config All_List",
        List: "Config List",
        Edit: "Config Edit",
    };

    // Entity
    public static Entity = {
        List: "Entity List",
        Create: "Entity Create",
        Edit: "Entity Edit",
        Delete: "Entity Delete",
    };

    // Events
    public static Events = {
        List: "Event List",
        Create: "Create Events",
        Edit: "Edit Events",
        Delete: "Delete Events",
    };

    // Payments
    public static Payments = {
        List: "Payment List",
        Refund: "Refund Payment",
    };
}

export const PermissionsDataList: IPermissionsList[] = Object.values(
    [
        ...mappingEnum(PermissionsLists),
        // ...mappingEnum(PermissionsLists.SplynxCRM),
        // ...mappingEnum(PermissionsLists.Logistics),
        // ...mappingEnum(PermissionsLists.Inventory),
        // ...mappingEnum(PermissionsLists.Commercial),
        // ...mappingEnum(PermissionsLists.Management),
    ].flat(),
)
    .map(
        /**
         * Maps each permission to an object with role, permissions, and adminOnly properties.
         * @param v - The permission object.
         * @returns An object with role, permissions, and adminOnly properties.
         */
        (v): IPermissionsList => ({
            role: v.key,
            permissions: [
                ...Object.values(v.value).map((p) => ({
                    name: `${p}`,
                    value: false,
                })),
            ],
            adminOnly: false,
        }),
    )
    .sort((a, b) => a.role.localeCompare(b.role));
